<div class="tags">
  <div class="tag" *ngFor="let tag of tags"
       [style.color]="tag.color"
       [style.background-color]="tag.color+'20'">
    {{ tag.name }}
  </div>
</div>
